import request from '@/utils/request'

export function setSvcAsk(params) {
    return request({
        url: '/v2/cs/setSvcAsk',
        method: 'post',
        data: params
    })
}